const medicalMachine = 'MedicalMachine'
const reservation = 'Reservation'
const item = 'Item'
const packageEntity = 'Package'

const RESERVATION_NUMBER = 4
const ITEM_CATEGORY_NUMBER = 3
const ITEM_NUMBER = 2
const MEDICAL_MACHINE_NUMBER = 1

const DOCTOR_NUMBER = 4
const EMPLOYEE_NUMBER = 5
const PATIENT_NUMBER = 6

export default {
  data () {
    return {
      MEDICAL_MACHINE: medicalMachine,
      RESERVATION: reservation,
      ITEM: item,
      PACKAGE: packageEntity,
      RESERVATION_NUMBER: RESERVATION_NUMBER,
      ITEM_NUMBER: ITEM_NUMBER,
      MEDICAL_MACHINE_NUMBER: MEDICAL_MACHINE_NUMBER,
      DOCTOR_NUMBER: DOCTOR_NUMBER,
      EMPLOYEE_NUMBER: EMPLOYEE_NUMBER,
      PATIENT_NUMBER: PATIENT_NUMBER,
      ITEM_CATEGORY_NUMBER: ITEM_CATEGORY_NUMBER
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/packageEntities.js